/**
 * Straight-line distance between two points, in kilometres (haversine).
 *
 * Emergency Help (M35-T06, ADR-0064) works distance out HERE, in the browser,
 * so the patient's location never reaches the server. It is a straight line,
 * not a road distance or a travel time, and the screen says so.
 */
const EARTH_RADIUS_KM = 6371

export type Point = { lat: number; lng: number }

export function distanceKm(a: Point, b: Point): number {
  const rad = (d: number) => (d * Math.PI) / 180
  const dLat = rad(b.lat - a.lat)
  const dLng = rad(b.lng - a.lng)
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h))
}

/** "850 m", "2.4 km", "31 km". */
export function formatDistance(km: number): string {
  if (km < 1) return `${Math.max(10, Math.round((km * 1000) / 10) * 10)} m`
  if (km < 10) return `${km.toFixed(1)} km`
  return `${Math.round(km)} km`
}
